import { useEffect, useState} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { setManagers, setSchedule } from "../redux/modules/meeting";
import { setRealtyProjects, setRealtyTypes } from "../redux/modules/realty";
import { api } from '../redux/api'

const useFetchData = () => {
  const dispatch = useDispatch();
  const [loadingdatas, setLoading] = useState(false);
  
  const auth = useSelector(state => state.auth);
  const projects = useSelector(state => state.realty.projects);
  const types = useSelector(state => state.realty.types);
  const managers = useSelector(state => state.meeting.managers);

  useEffect(()=> {
    if(auth.user !== null && (!projects || !types || !managers)) {
      fetch(api + "?cmd=realty-getprojects&_debug_token=" + auth.token).then(res => res.json())
        .then(project => {
          //console.log(project)
          dispatch(setRealtyProjects(project))
          fetch(api + "?cmd=realty-gettypes&_debug_token=" + auth.token).then(res => res.json())
            .then(type => {
             // console.log(type)
              dispatch(setRealtyTypes(type))
              
              Promise.all(
                project.content.ProjectsInfo.map(pr => {
                  return Promise.all(type.content.TypesInfo.map(tp =>  {
                    return fetch(api + "?cmd=orders-getmanagers&projectId=" + pr.id + "&typeId=" + tp.id + "&_debug_token=" + auth.token)
                      .then(res => res.json())
                      .then((result) => result.content.ManagersInfo.map((item) => {                
                        item.projectId = pr.id
                        item.typeId = tp.id
                        return item
                      }))
                  }))
                })
              )
              .then((responses) => {
                //console.log(...responses); 
                let mngrs = [];
                responses[0].map((item) => mngrs.push(...item))
                
                //console.log(mngrs);
                dispatch(setManagers(mngrs))
                
                /*let eventTypeId = [1,2]
                let formatId = [1,2]
                Promise.all(
                  mngrs.map((manager, i) => {                  
                    return Promise.all(eventTypeId.map((event, i = event) => {
                      return Promise.all(
                        formatId.map((format, key = format) => {
                          return fetch(api + "?cmd=orders-getschedule&managerId=" + manager.id + "&eventTypeId=" + event + "&formatId=" + format + "&_debug_token=" + auth.token)
                            .then(res => res.json())
                            .then((result) => result.content.TimeslotInfo.map((item) => {                
                              item.managerId = manager.id
                              item.eventTypeId = event
                              item.formatId = format
                              return item
                            }))
                          })
                      )
                    }))
                  })
                )
                .then((responses) => {
                  //console.log(responses);  
                  
                  let schdl = Object.fromEntries(
                    Object.entries(responses).map(([key, value]) => [parseInt(key) + 1, Object.fromEntries(Object.entries(value).map(([key2, value2]) => [parseInt(key2) + 1, Object.fromEntries(Object.entries(value2).map(([key3, value3]) => [parseInt(key3) + 1, value3]))]))])
                  );
                  
                  //console.log(schdl);    
                  dispatch(setSchedule(schdl));                
                  setLoading(false)
                })*/
                
              })

              
            })
        })  
    } else { 
      setLoading(false)
    }
  }, [])

  return {
    projects,
    types,
    managers,
    loadingdatas,
  };
};

export default useFetchData;